import { render, staticRenderFns } from "./EmployeeDeductionsComponent.vue?vue&type=template&id=5e7cc17a&"
import script from "./EmployeeDeductionsComponent.vue?vue&type=script&lang=js&"
export * from "./EmployeeDeductionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports